<template>
  <ul class="insight-list">
    <li v-for="insight in insights" :key="insight.url">
      <a class="insight-card" :href="insight.url" target="_blank" rel="noopener">
        <div class="insight-card__thumb">
          <img :src="insight.image" alt="" loading="lazy" @error="useImageFallback">
        </div>
        <div class="insight-card__body">
          <div class="insight-card__meta">
            <span class="tag solid sm">{{ insight.category }}</span>
            <time v-if="insight.date" class="text-caption" :datetime="insight.date">{{ insight.date }}</time>
          </div>
          <h3 class="insight-card__title">{{ insight.title }}</h3>
        </div>
      </a>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { useRenewalInsights } from '../composables/useRenewalInsights'

// 데이터 출처는 호스트가 정한다 — 단독이면 자체 /api/insights, 다른 앱에 얹히면
// 그 앱의 뉴스 API. 여기서 경로를 직접 부르면 얹히는 순간 빈 목록이 된다.
//
// 5개인 이유: CSS 가 "왼쪽 대표 카드 1개 + 오른쪽 목록 4개" 한 벌을 전제한다
// (`grid-template-rows: repeat(4, 1fr)` + 첫 항목 `grid-row: 1 / -1`).
// 더 넣으면 여섯 번째가 왼쪽 열로 넘어가 대표 카드 아래에 끼어든다.
const { data: insights } = await useRenewalInsights(5, ['news'])

function useImageFallback(event: Event) {
  const image = event.currentTarget as HTMLImageElement
  if (image.src.endsWith('/images/insight-placeholder.svg')) return
  image.src = '/images/insight-placeholder.svg'
}
</script>
